/* ============================================================
   YUKI SALON – Main JavaScript
   ============================================================ */

document.addEventListener('DOMContentLoaded', () => {

  /* --- Sticky Header --- */
  const header = document.querySelector('.site-header');
  if (header) {
    const onScroll = () => {
      header.classList.toggle('scrolled', window.scrollY > 60);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* --- Mobile Menu --- */
  const toggle = document.querySelector('.menu-toggle');
  const mobileNav = document.querySelector('.mobile-nav');
  if (toggle && mobileNav) {
    const setMenuState = (open) => {
      toggle.classList.toggle('active', open);
      mobileNav.classList.toggle('active', open);
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      mobileNav.setAttribute('aria-hidden', open ? 'false' : 'true');
      document.body.style.overflow = open ? 'hidden' : '';
    };
    toggle.addEventListener('click', () => {
      setMenuState(!mobileNav.classList.contains('active'));
    });
    mobileNav.querySelectorAll('a').forEach(link => {
      link.addEventListener('click', () => setMenuState(false));
    });
    /* Close on Escape */
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && mobileNav.classList.contains('active')) {
        setMenuState(false);
        toggle.focus();
      }
    });
    /* Close on route change, including back/forward restores from cache */
    window.addEventListener('pagehide', () => setMenuState(false));
    window.addEventListener('popstate', () => setMenuState(false));
  }

  /* --- Smooth Scroll for Anchor Links --- */
  document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', (e) => {
      const id = anchor.getAttribute('href');
      if (id === '#') return;
      const target = document.querySelector(id);
      if (target) {
        e.preventDefault();
        const offset = header ? header.offsetHeight : 0;
        const top = target.getBoundingClientRect().top + window.scrollY - offset;
        window.scrollTo({ top, behavior: 'smooth' });
      }
    });
  });

  /* --- Scroll Reveal Animations --- */
  const observerOptions = {
    threshold: 0.15,
    rootMargin: '0px 0px -40px 0px'
  };

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('visible');
        observer.unobserve(entry.target);
      }
    });
  }, observerOptions);

  document.querySelectorAll('.fade-up, .fade-in').forEach(el => {
    observer.observe(el);
  });

  /* NO SAFETY NET. Two were shipped and both were unnecessary.
     Recorded here so a third is not attempted.

     Phase 17 added a blanket net that revealed every unrevealed .fade-up after
     three seconds, because a sweep reported content "permanently invisible" on
     two pages. Phase 19 replaced it with a rectangle test plus a second pass,
     because one pass appeared to miss two blocks.

     Neither defect existed. Tested by neutralising the net in flight, waiting a
     full two seconds without sampling, then sampling once: the only elements
     still faded on any page were `fac-hifu__media` at top 887 and
     `visit__form-wrap` at top 889, in a 900px viewport. The observer runs with
     `rootMargin: '0px 0px -40px 0px'`, so its effective root bottom is 860.
     An element starting at 887 is OUTSIDE the root and correctly reports zero
     intersection; it is below the fold as far as the observer is concerned.

     The bug was in the test: it compared against window.innerHeight (900) rather
     than the observer's effective root bottom (860), so two below-fold elements
     were classified as in-view. Both "defects" were the ruler.

     If a reveal ever does look stuck, check these before touching this file:
       1. can the harness actually scroll? window.scrollTo moves 0.5px here
       2. is the element below root bottom, i.e. innerHeight MINUS the rootMargin
       3. has a full frame elapsed? observer callbacks are delivered async
  */

  /* --- Stagger children --- */
  document.querySelectorAll('[data-stagger]').forEach(parent => {
    const children = parent.children;
    Array.from(children).forEach((child, i) => {
      child.style.transitionDelay = `${i * 0.1}s`;
    });
  });

  /* --- Accordions --- */
  document.querySelectorAll('.cv-accordion__trigger, .price-accordion__trigger').forEach(trigger => {
    trigger.addEventListener('click', () => {
      const panel = trigger.nextElementSibling;
      const isOpen = trigger.classList.contains('active');

      // Close siblings
      const parent = trigger.closest('.cv-accordion, .price-category');
      if (parent) {
        parent.querySelectorAll('.cv-accordion__trigger.active, .price-accordion__trigger.active').forEach(t => {
          if (t !== trigger) {
            t.classList.remove('active');
            t.nextElementSibling.classList.remove('open');
            t.nextElementSibling.style.maxHeight = null;
          }
        });
      }

      trigger.classList.toggle('active', !isOpen);
      panel.classList.toggle('open', !isOpen);
      if (!isOpen) {
        panel.style.maxHeight = panel.scrollHeight + 'px';
      } else {
        panel.style.maxHeight = null;
      }
    });
  });

  /* --- Embroidery Tabs --- */
  const tabContainer = document.querySelector('.embroidery-tabs');
  if (tabContainer) {
    const tabs = tabContainer.querySelectorAll('button');
    const panels = document.querySelectorAll('.embroidery-panel');

    tabs.forEach(tab => {
      tab.addEventListener('click', () => {
        const target = tab.dataset.tab;
        tabs.forEach(t => t.classList.remove('active'));
        panels.forEach(p => p.classList.remove('active'));
        tab.classList.add('active');
        document.querySelector(`[data-panel="${target}"]`).classList.add('active');
      });
    });
  }

  /* --- Contact Form Character Count --- */
  const textarea = document.querySelector('.contact-form textarea');
  const charCount = document.querySelector('.char-count');
  if (textarea && charCount) {
    textarea.addEventListener('input', () => {
      charCount.textContent = `${textarea.value.length} / 180`;
    });
  }

  /* --- Parallax on Hero --- */
  const heroBg = document.querySelector('.hero__bg');
  if (heroBg && window.matchMedia('(min-width: 768px)').matches) {
    window.addEventListener('scroll', () => {
      const scrolled = window.scrollY;
      if (scrolled < window.innerHeight) {
        heroBg.style.transform = `translateY(${scrolled * 0.3}px)`;
      }
    }, { passive: true });
  }

});

/* Hero slider — fade auto-rotate */
(function(){
  var s=document.querySelector('[data-hero-slider]');
  if(!s) return;
  var slides=s.querySelectorAll('.hero__slide');
  if(slides.length<2) return;
  var i=0, iv=parseInt(s.getAttribute('data-interval'),10)||5500;
  setInterval(function(){
    slides[i].classList.remove('is-active');
    i=(i+1)%slides.length;
    slides[i].classList.add('is-active');
  }, iv);
})();
